import { createContext, useCallback, useContext, useMemo, useState, Suspense, lazy } from 'react'

type WaitlistContextValue = {
  openWaitlist: () => void
  closeWaitlist: () => void
}

const WaitlistContext = createContext<WaitlistContextValue | undefined>(undefined)

const WaitlistDrawer = lazy(() => import('../components/Waitlist/WaitlistDrawer'))

export function WaitlistProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const openWaitlist = useCallback(() => setIsOpen(true), [])
  const closeWaitlist = useCallback(() => setIsOpen(false), [])

  const value = useMemo(() => ({ openWaitlist, closeWaitlist }), [openWaitlist, closeWaitlist])

  return (
    <WaitlistContext.Provider value={value}>
      {children}
      <Suspense fallback={null}>
        {isOpen && <WaitlistDrawer open={isOpen} setOpen={setIsOpen} />}
      </Suspense>
    </WaitlistContext.Provider>
  )
}

export function useWaitlist() {
  const ctx = useContext(WaitlistContext)
  if (!ctx) throw new Error('useWaitlist must be used within WaitlistProvider')
  return ctx
}
